import { types } from '@actions/trscService';

export const initialState = {
  languages: [],
  isFetchingLanguages: false,
  isAITranscriptionEnabled: true,
  isHumanTranscriptionEnabled: true,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_AVAILABLE_LANGUAGES.REQUEST: {
      return { ...state, languages: [], isFetchingLanguages: true };
    }
    case types.GET_AVAILABLE_LANGUAGES.SUCCESS: {
      const { payload: languages } = action;
      return { ...state, languages, isFetchingLanguages: false };
    }
    case types.GET_AVAILABLE_LANGUAGES.FAILURE: {
      return { ...state, languages: [], isFetchingLanguages: false };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/trscService.js